import { PromoSlice } from './reducer';

export const isVendorPromoEmptySelector = (state: PromoSlice) => {
    return state.promo.promos.length === 0;
};

export const vendorPromosSelector = (state: PromoSlice) => {
    return state.promo.promos;
};
